import React, { useContext, useState, useRef, useCallback } from 'react';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import { useWidgetTranslates } from '../../../common/utils/utils';
import css from './ExelDownload.module.scss';
import classNames from 'classnames';
import { Portal } from '../../../hybrid/wrappers';
import ProgressBar from '../../ProgressBar/ProgressBar';
import { t } from '../../../common/components/T';
import Plug from '../../plug/Plug/Plug';
import exel_is_creating from '../../../public/src/img/plugs/exel_is_creating.svg';
import exel_is_creating_office from '../../../public/src/img/plugs/exel_is_creating_gt.svg';

export const useExelDownload = (exportUrl, exportData, customStyles) => {
    const { userToken, lang, setAlertData } = useContext(UserContext);
    const { adminPage } = useContext(UserProfileContext);

    const trans = useWidgetTranslates('excel');

    const [exportStatus, setExportStatus] = useState(false);
    let [progress, setProgress] = useState(0);
    const styles = { ...css, ...customStyles };

    const download = useCallback(
        (url) => {
            fetch(url, {
                headers: {
                    ...(userToken || exportData?.token
                        ? {
                              Authorization: `Bearer ${exportData?.token ? exportData?.token : userToken}`
                          }
                        : {}),
                    ...(lang ? { 'Accept-Language': lang } : {})
                }
            })
                .then((response) => response.blob())
                .then((blob) => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = exportData.filename;
                    link.click();
                })
                .catch(console.error);

            setTimeout(() => {
                setExportStatus(false);
                setProgress(0);
            }, 500);
        },
        [exportData?.filename, exportData?.token, lang, userToken]
    );

    const timeout = useRef();
    const getExel = useCallback(
        async (url, download_link) => {
            clearTimeout(timeout?.current);
            let headers = {
                ...(userToken || exportData?.token
                    ? {
                          Authorization: `Bearer ${exportData?.token ? exportData?.token : userToken}`
                      }
                    : {}),
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...(lang ? { 'Accept-Language': lang } : {})
            };

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers
                });

                let receivedLength = 0;
                let chunks = [];
                let contentLength = 0;

                console.log(response);

                if (response.status === 200) {
                    if (response.headers.has('Content-Length') && response.headers.get('Content-Type') !== 'application/json') {
                        const reader = response.body.getReader();
                        contentLength = +response.headers.get('Content-Length');

                        while (true) {
                            const { done, value } = await reader.read();

                            if (done) {
                                break;
                            }

                            chunks.push(value);
                            receivedLength += value.length;

                            setProgress(Math.round((receivedLength / contentLength) * 100));
                        }
                        let blob = new Blob(chunks);

                        var myFileRider = new FileReader();
                        myFileRider.onloadend = function () {
                            download(myFileRider.result);
                        };
                        myFileRider.readAsDataURL(blob);
                    } else {
                        const data = await response.json();
                        if (!!data?.data?.finished) {
                            setProgress(100);
                            if (data?.data?.download_link || download_link) {
                                download(data?.data?.download_link || download_link);
                            } else {
                                setExportStatus(false);
                                setProgress(0);
                            }
                        } else {
                            setProgress(data?.data?.progress);
                            timeout.current = setTimeout(() => {
                                getExel(data?.data?.queue_link || url, data?.data?.download_link || download_link);
                            }, 1500);
                        }
                    }
                } else {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_get_data'
                    });
                    setExportStatus(false);
                    setProgress(0);
                }
            } catch {
                setAlertData({
                    type: 'error',
                    cont: true,
                    default: 'error_get_data'
                });
                setExportStatus(false);
                setProgress(0);
            }
        },
        [download, exportData?.token, lang, setAlertData, userToken]
    );

    const onClick = useCallback(() => {
        setExportStatus(true);
        getExel(exportUrl);
    }, [getExel, exportUrl]);

    return {
        onClick,
        Modal: !!exportStatus ? (
            <Portal
                closeHandler={() => {
                    clearTimeout(timeout?.current);
                    setExportStatus(false);
                    setProgress(0);
                }}
                // customClass='modalTop'
                fullWidth
                fullHeight
            >
                <div className={styles.wrapper}>
                    <div className={classNames(styles.modalContentWrapper || '', styles.modalContentWrapperMD || '')}>
                        <Plug
                            classes={{
                                plugContainer: [css.plugOffsets]
                            }}
                            plugImg={adminPage ? exel_is_creating : exel_is_creating_office}
                            plugTitle={t(
                                'Excel_exelFileInProgress-modalTitle-',
                                'Формируется Excel файл',
                                'widget',
                                trans,
                                'excel'
                            )}
                            plugDescription={t(
                                'Excel-modalText',
                                'Пожалуйста, подождите, пока файл будет готов к скачиванию',
                                'widget',
                                trans,
                                'excel'
                            )}
                        />
                        <ProgressBar progress={progress}></ProgressBar>
                    </div>
                </div>
            </Portal>
        ) : null
    };
};
